import React from 'react';
import { Button, Checkbox, FormControl, FormControlLabel, FormHelperText, Grid, InputAdornment, Typography, } from '@mui/material';
import { useForm } from 'react-hook-form';
import { Types } from '@wheeebo/polaris-api';
import ValidatableField from './ValidatableField';
function MoveGlobalForm({ onSubmit }) {
    const { register, formState, handleSubmit: validate } = useForm({ mode: 'onChange' });
    const { errors } = formState;
    const [disabled, setDisabled] = React.useState(true);
    const [vertical, setVertical] = React.useState();
    const [horizontal, setHorizontal] = React.useState();
    const [forward, setForward] = React.useState();
    const [speed, setSpeed] = React.useState();
    const [land, setLand] = React.useState();
    const handleSubmit = () => {
        setDisabled(true);
        onSubmit(Types.VehicleCommandMoveVehicleRelative, { vertical, horizontal, forward, speed: speed, land });
        setTimeout(() => setDisabled(false), 2500);
    };
    React.useEffect(() => setDisabled(!vertical && !horizontal && !forward), [vertical, horizontal, forward]);
    return (React.createElement("form", { onSubmit: validate(handleSubmit) },
        React.createElement(Grid, { container: true, spacing: 1 },
            React.createElement(Grid, { item: true, xs: 12 },
                React.createElement(Typography, { variant: "body2" }, "Specify the distance of destination from the current position.")),
            React.createElement(Grid, { item: true, xs: 12, sm: 6 },
                React.createElement(FormControl, { component: "fieldset", fullWidth: true },
                    React.createElement(ValidatableField, { id: "vertical", label: "Vertical", helperTexts: ['A positive number is for a upward move and a negative is for downward.'], placeholder: "10", type: "number", InputProps: {
                            endAdornment: React.createElement(InputAdornment, { position: "end" }, "m"),
                        }, inputProps: {
                            step: 'any',
                        }, value: vertical, registerOptions: {
                            onChange: (e) => setVertical(parseFloat(e.target.value)),
                        }, register, errors }))),
            React.createElement(Grid, { item: true, xs: 12, sm: 6 },
                React.createElement(FormControl, { component: "fieldset", fullWidth: true },
                    React.createElement(ValidatableField, { id: "horizontal", label: "Horizontal", helperTexts: ['A positive number is for the poistion to the left move and a negative for the right.'], placeholder: "10", type: "number", InputProps: {
                            endAdornment: React.createElement(InputAdornment, { position: "end" }, "m"),
                        }, inputProps: {
                            step: 'any',
                        }, value: horizontal, registerOptions: {
                            onChange: (e) => setHorizontal(parseFloat(e.target.value)),
                        }, register, errors }))),
            React.createElement(Grid, { item: true, xs: 12, sm: 6 },
                React.createElement(FormControl, { component: "fieldset", fullWidth: true },
                    React.createElement(ValidatableField, { id: "forward", label: "Forward", helperTexts: ['A positive number is for a forward move and a negative is for backward.'], placeholder: "10", type: "number", InputProps: {
                            endAdornment: React.createElement(InputAdornment, { position: "end" }, "m"),
                        }, inputProps: {
                            step: 'any',
                        }, value: forward, registerOptions: {
                            onChange: (e) => setForward(parseFloat(e.target.value)),
                        }, register, errors }))),
            React.createElement(Grid, { item: true, xs: 12, sm: 6 },
                React.createElement(FormControl, { component: "fieldset", fullWidth: true },
                    React.createElement(ValidatableField, { id: "speed", label: "Speed", helperTexts: ['Speed of the flight to the destination'], placeholder: "1", type: "number", InputProps: {
                            endAdornment: React.createElement(InputAdornment, { position: "end" }, "m/s"),
                        }, inputProps: {
                            step: 'any',
                        }, value: speed, registerOptions: {
                            onChange: (e) => setSpeed(parseFloat(e.target.value)),
                        }, register, errors }))),
            React.createElement(Grid, { item: true, xs: 12 },
                React.createElement(FormControlLabel, { control: React.createElement(Checkbox, { value: land, onChange: (_, checked) => setLand(checked) }), label: "Land the vehicle after the flight" }),
                React.createElement(FormHelperText, null, "Tick a box if the vehicle needs to land after the flight to the destination. ")),
            React.createElement(Grid, { item: true, xs: 12, sx: { display: 'flex', justifyContent: 'flex-end' } },
                React.createElement(Button, { type: "submit", disabled: disabled }, "Submit")))));
}
export default React.memo(MoveGlobalForm);
